import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { createSelector } from './selectorWrapper'
import { pageSelectors } from './basicState'
import { isGen4TitleType } from '../utils/titleTypes'
import { isLiveEntityType } from '../utils/entityTypes'
import { isTV } from '../utils/entityTypes'

export const isTVSelector = createSelector(
  pageSelectors.headerDetail,
  isTV
)

export const isGen4 = createSelector(
  pageSelectors.self,
  (self?: WpsRuntime.atv.wps.SelfFragmentModelProps) => Boolean(self && isGen4TitleType(self.titleType))
)

export const isLiveEventTitleSelector = createSelector(
  pageSelectors.detail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) => isLiveEntityType(detailFragment && detailFragment.entityType)
)

export const isStarlightEnhancedSelector = createSelector(
  [pageSelectors.detail, pageSelectors.headerDetail],
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps,
   headerFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) =>
    !global.__NATIVEAPP__ && (detailFragment && detailFragment.isStarlightEnhanced || headerFragment && headerFragment.isStarlightEnhanced)
)
